// extracted by mini-css-extract-plugin
module.exports = {"container":"up-vote-button_container__qaLRp","voteAction":"up-vote-button_voteAction__nWWk9"};